import { FC, useState, useEffect } from 'react'
import { BottomArea } from '../BottomArea/BottomArea'
import { Message, Page } from '../components'
import { MapModal } from '../components/modal/Modal'
import { MapComponent } from './MapComponent'
import { NO_BORDER_ACTIVATED_ONCE_KEY, TENT_ICON_KEY } from './constants/map'
import { useParams } from 'react-router-dom'

export const MapContainer: FC = () => {
  const params = useParams()
  const showNoBorder =
    params.filter === 'no-border' || params.filter === 'noborder'

  const isTentUnset = !localStorage.getItem(TENT_ICON_KEY)
  const isNoBorderUnset = !localStorage.getItem(NO_BORDER_ACTIVATED_ONCE_KEY)
  const [isTentModalOpen, setIsTentModalOpen] = useState(false)
  const [isNoBorderModalOpen, setIsNoBorderModalOpen] = useState(false)

  // Initialize modals based on route and localStorage state
  useEffect(() => {
    if (showNoBorder && isNoBorderUnset) {
      setIsNoBorderModalOpen(true)
    } else if (isTentUnset) {
      setIsTentModalOpen(true)
    }
  }, [showNoBorder, isNoBorderUnset, isTentUnset])

  const handleNoBorderModalClose = () => {
    setIsNoBorderModalOpen(false)
    localStorage.setItem(NO_BORDER_ACTIVATED_ONCE_KEY, 'true')

    // Show tent modal after no-border modal is closed
    if (isTentUnset) {
      setIsTentModalOpen(true)
    }
  }

  const handleTentModalClose = () => {
    setIsTentModalOpen(false)
  }

  return (
    <Page withBackground>
      <MapComponent />
      <MapModal
        isOpen={isTentModalOpen}
        title={<Message id="TENT_TITLE" />}
        text={<Message id="TENT_MESSAGE" />}
        onClose={handleTentModalClose}
      />
      <MapModal
        isOpen={isNoBorderModalOpen}
        title={<Message id="NO_BORDER_TITLE" />}
        text={<Message id="NO_BORDER_MESSAGE" />}
        onClose={handleNoBorderModalClose}
      />
      <BottomArea showFilterButton={false} gradientType="none" />
    </Page>
  )
}
